import React from 'react';

export default function VersionInfo({ versionData }) {
    if (versionData) {
        let completeClassName;
        switch(versionData.Status) {
            case "Completed":
                completeClassName = "far fa-dot-circle text-green-500 mr-2";
                break;
            case "Submitted":
                completeClassName = "far fa-dot-circle text-orange-500 mr-2";
                break;
            case "Query Submit":
                completeClassName = "far fa-dot-circle text-yellow-500 mr-2";
                break;
            case "Created":
                completeClassName = "far fa-dot-circle text-gray-500 mr-2";
                break;
            default:
                completeClassName = "";
                break;
        }
        return (
            <div className="p-5 ml-5 mb-10 bg-white shadow">
                <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">Version Details</h2>
                <div className="flex justify-between mt-5 mb-2 px-6 pb-1 border-b border-dashed border-gray-200">
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect">
                            Version
                        </label>
                        <p className="text-md text-gray-800">
                            {versionData.Version}
                        </p>
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect">
                            Status
                        </label>
                        <p className="text-md text-gray-800">
                            <i className={completeClassName}></i>
                            {versionData.Status}
                        </p>
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect">
                            Start Date
                        </label>
                        <p className="text-md text-gray-800">
                            {new Date(versionData.FromDate).toLocaleDateString()}
                        </p>
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect">
                            End Date
                        </label>
                        <p className="text-md text-gray-800">
                            {new Date(versionData.ToDate).toLocaleDateString()}
                        </p>
                    </div>
                </div>
                {versionData.VersionDescription && (
                    <div className="flex flex-col justify-center px-6 pb-1 border-b border-dashed border-gray-200">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect">
                            Description
                        </label>
                        <p className="text-md text-gray-800">
                            {versionData.VersionDescription}
                        </p>
                    </div>
                )}
            </div>
        )
    } else {
        return <div></div>;
    }
}